import { applyQueryString } from "lib/queryString";
import { apiGeneral } from "services";
import { ICity } from "interfaces/city";

export function useCities() {
  const getCities = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/cities`, filter);
    const { data } = await apiGeneral.get<ICity[]>(url);

    const comboOptions = data.map((city: ICity) => ({
      value: city.name,
      name: city.name,
      ibge: city.ibge,
    }));

    return comboOptions;
  };
  const getCEP = async (CEP: string | null): Promise<any> => {
    if (CEP) {
      const {data} = await apiGeneral.get<ICity[]>(`/cep/${CEP}`);
      return data;
    } else {
      return null;
    }
  };

  return { getCities, getCEP };
}
